// src/components/NavBar.js
import React from 'react';
import { Link } from 'react-router-dom';
import { useCart } from '../context/CartContext';

function NavBar() {
  const { cart } = useCart();
  const itemCount = cart.reduce((sum, item) => sum + item.quantity, 0);

  return (
    <nav className="bg-white shadow-sm py-2">
      <div className="max-w-screen-xl mx-auto px-4 py-3 flex items-center justify-between">
        {/* Logo */}
        <Link to="/" className="flex items-center gap-2">
          <img src="/images/icon.png" alt="Shophub Logo" className="h-8" />
          <span className="text-2xl font-semibold text-gray-800">Shophub</span>
        </Link>

        {/* Cart Icon */}
        <Link to="/cartpage" className="relative text-3xl text-gray-700">
          <i className="bx bx-cart-alt"></i>
          {itemCount > 0 && (
            <span className="absolute -top-2 -right-2 bg-red-500 text-white text-xs font-bold rounded-full w-5 h-5 flex items-center justify-center">
              {itemCount}
            </span>
          )}
        </Link>
      </div>
    </nav>
  );
}

export default NavBar;
